import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔴',
  title: 'Tomo 1 — Mentalidad y Preparación Inteligente',
  subtitle: 'Pilar PREVER: Aprendé a pensar con claridad',
  accent: 'border-l-red-500',
  items: ['Cómo desarrollar una mentalidad de preparación moderna', 'Qué errores comete la mayoría ante crisis', 'Cómo priorizar recursos realmente importantes', 'Organización mental frente a incertidumbre y caos', 'Cómo crear un plan familiar simple y efectivo', 'Preparación inteligente sin survivalismo extremo']
}, {
  icon: '🔵',
  title: 'Tomo 2 — Agua y Alimentación Esencial',
  subtitle: 'Pilar RESERVAR: Sostené tu hogar ante cortes',
  accent: 'border-l-blue-500',
  items: ['Métodos seguros de almacenamiento de agua', 'Sistemas básicos de purificación y filtrado', 'Cómo calcular reservas para 7, 15 y 30 días', 'Alimentos estratégicos de larga duración', 'Conservación doméstica de productos esenciales', 'Cocina práctica sin electricidad o gas']
}, {
  icon: '🟢',
  title: 'Tomo 3 — Conservación y Autosuficiencia',
  subtitle: 'Pilar ADAPTARSE: Extendé recursos y autonomía',
  accent: 'border-l-green-500',
  items: ['Técnicas simples de deshidratación casera', 'Conservación natural de alimentos', 'Introducción práctica a la fermentación', 'Cómo iniciar un huerto doméstico básico', 'Semillas esenciales y almacenamiento correcto', 'Producción de alimentos en espacios pequeños']
}, {
  icon: '🟡',
  title: 'Tomo 4 — Medicina Natural y Primeros Auxilios',
  subtitle: 'Pilar PROTEGER: Respondé mejor en emergencias',
  accent: 'border-l-yellow-400',
  items: ['Cómo armar un botiquín inteligente y funcional', 'Elementos esenciales de primeros auxilios', 'Uso básico de plantas medicinales comunes', 'Remedios naturales tradicionales y prácticos', 'Prevención doméstica y cuidados básicos de salud', 'Qué hacer ante heridas, golpes y emergencias']
}, {
  icon: '⚫',
  title: 'Tomo 5 — Supervivencia Urbana y del Hogar',
  subtitle: 'Pilar ESTABILIZAR: Mantené funcionalidad crítica',
  accent: 'border-l-gray-500',
  items: ['Preparación para apagones prolongados', 'Sistemas básicos de iluminación de emergencia', 'Herramientas esenciales para el hogar preparado', 'Energía alternativa y respaldo básico', 'Seguridad doméstica en contextos urbanos', 'Comunicación durante cortes o fallas']
}, {
  icon: '🟣',
  title: 'Tomo 6 — Autonomía Sin Tecnología',
  subtitle: 'Pilar INDEPENDIZARSE: Dependé menos del sistema',
  accent: 'border-l-purple-500',
  items: ['Orientación básica sin GPS ni internet', 'Uso práctico de mapas físicos y brújula', 'Habilidades manuales útiles para el hogar', 'Resolución de problemas sin tecnología', 'Organización comunitaria y redes de apoyo', 'Cómo adaptarse ante fallas tecnológicas']
}];
const features = ['guías paso a paso', 'herramientas prácticas', 'ejemplos reales', 'aplicación inmediata', 'preparación doméstica moderna'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-premium-gradient pt-6 pb-6 px-5 relative overflow-hidden" data-id="element-328">
      <div className="absolute inset-0 bg-radial-glow opacity-40 pointer-events-none" data-id="element-329" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-330">
        <h2 className="text-3xl md:text-4xl font-black text-center text-white mb-3" data-id="element-331">
          📚 LO QUE RECIBÍS
        </h2>
        <p className="text-center text-blue-400/80 text-sm font-medium mb-6 uppercase tracking-widest" data-id="element-332">
          6 tomos completos de alto valor
        </p>

        <div className="space-y-4 mb-6" data-id="element-333">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-white/5 backdrop-blur-sm border border-white/10 border-l-4 ${tomo.accent} rounded-lg overflow-hidden transition-all hover:bg-white/10`} data-id="element-334">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-335">
                  <span className="text-2xl flex-shrink-0" data-id="element-336">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-337">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-338">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-339">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-340" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-341" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-342">
                    <div className="space-y-2" data-id="element-343">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-344">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-345" />
                          <span className="text-xs text-gray-400" data-id="element-346">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-0" data-id="element-347">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-4" data-id="element-348">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-349">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-350">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-351" />
                <span className="text-sm text-gray-300 font-medium" data-id="element-352">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}